import { GameConfig } from '../types/memory-game.types';

export const GAME_CONFIG: GameConfig = {
  easy: {
    rows: 3,
    cols: 4,
    totalCards: 12,
    pairs: 6
  },
  medium: {
    rows: 4,
    cols: 4,
    totalCards: 16,
    pairs: 8
  },
  hard: {
    rows: 4,
    cols: 6,
    totalCards: 24,
    pairs: 12
  },
  expert: {
    rows: 6,
    cols: 6,
    totalCards: 36,
    pairs: 18
  }
};

export const EMOJI_SET = [
  '😀', '😃', '😄', '😁', '😆', '😊', '😍', '🥰', '😘', '😋',
  '😛', '😜', '🤓', '😎', '🤩', '🥳', '😏', '🙃', '😉', '😌',
  '🤪', '🧐', '😇', '🙂', '😗', '😙', '😚', '😝', '😤', '😠',
  '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓'
];

export const GAME_SETTINGS = {
  FLIP_DELAY: 800, // Time before mismatched cards flip back
  HINT_HIGHLIGHT_DURATION: 2000, // How long hint highlights last
  MAX_HINTS_PER_GAME: 3,
  HINT_INACTIVITY_TIMEOUT: 30000, // 30 seconds of inactivity before auto-hint
  CARD_ANIMATION_DURATION: 300 // Card flip animation duration
};
